<div class="flex flex-col flex-auto w-full">
  <div class="container">
    <!-- Header -->
    <div class="top-header">
      <div class="page-title">Inward Stock List</div>
      <div class="header-right">
        <span>Home / Inward / Inward Stock List</span>
        <button
          nz-button
          nzType="default"
          class="go-back-btn"
          (click)="goBack()"
        >
          Go Back
        </button>
      </div>
    </div>

    <!-- Subheader -->
    <div class="sub-header">
      <div class="label">Inward Stock List</div>
      <div class="button-group">
        <button nz-button class="export-btn" (click)="exportToExcel()">
          Export to Excel
        </button>
      </div>
    </div>

    <div class="table-container">
      <!-- Form Section -->
      <div class="form-section">
        <label class="bold">Select Branch</label>
        <nz-select class="branch-select" [(ngModel)]="selectedBranch">
          @for (branch of branches; track branch) {
          <nz-option
            [nzValue]="branch.value"
            [nzLabel]="branch.label"
          ></nz-option>
          }
        </nz-select>
        <label
          nz-checkbox
          [(ngModel)]="selectAll"
          (ngModelChange)="handleSelectAllChange()"
          >Select All</label
        >
        <button nz-button nzType="primary" (click)="handleSubmit()">
          Submit
        </button>
      </div>

      <!-- Action Buttons -->
      <div class="action-buttons">
        <button nz-button nzType="primary" class="bulk-verify">
          Bulk Verify
        </button>
        <button nz-button nzDanger class="bulk-mismatched">
          Bulk Mismatched
        </button>
      </div>

      <!-- Table -->
      <app-data-grid
        [dataSource]="dataSource"
        [searchPanel]="false"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="false"
        [columnChooser]="false"
        [allowExport]="false"
        [pageSize]="10"
        [allowedPageSizes]="[5, 10, 20]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          dataField="sno"
          caption="S.No"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="user"
          caption="User"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="inward"
          caption="Inward"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="po"
          caption="PO"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="branch"
          caption="Branch"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="category"
          caption="Category"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="inventory"
          caption="Inventory"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="qty"
          caption="Qty"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="status"
          caption="Status"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="make"
          caption="Make"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="model"
          caption="Model"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="mag"
          caption="Mag"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="period"
          caption="Period"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          dataField="ware"
          caption="Ware"
          [allowSorting]="true"
        ></app-grid-column>

        <app-grid-column
          caption="Actions"
          [width]="100"
          cellTemplate="actionsTemplate"
        ></app-grid-column>

        <ng-template appGridCell="actionsTemplate" let-data="cell"
          ><div>
            <div class="action-buttons-container">
              <button
                nz-button
                nzType="primary"
                nzSize="small"
                (click)="openEditDrawer(data)"
              >
                <i nz-icon nzType="edit"></i>
              </button>
              <button
                nz-button
                nzType="danger"
                nzSize="small"
                (click)="openDeleteDrawer(data)"
              >
                <i nz-icon nzType="delete"></i>
              </button>
            </div></div
        ></ng-template>
      </app-data-grid>
    </div>
  </div>
</div>

<!-- Edit Drawer -->
<nz-drawer
  [nzVisible]="editDrawerVisible"
  nzTitle="Edit Inward"
  (nzOnClose)="closeDrawer()"
  [nzWidth]="520"
>
  <ng-container *nzDrawerContent>
    <div class="drawer-content">
      <p>Edit Inward Content</p>
    </div>
  </ng-container>
</nz-drawer>

<!-- Delete Drawer -->
<nz-drawer
  [nzVisible]="deleteDrawerVisible"
  nzTitle="Delete Inward"
  (nzOnClose)="closeDrawer()"
  [nzWidth]="520"
>
  <ng-container *nzDrawerContent>
    <div class="drawer-content">
      <p>Are you sure you want to delete this inward record?</p>
      <div class="drawer-footer">
        <button nz-button nzType="default" (click)="closeDrawer()">
          Cancel
        </button>
        <button nz-button nzType="danger" (click)="deleteRecord()">
          Delete
        </button>
      </div>
    </div>
  </ng-container>
</nz-drawer>

<!-- Outward Drawer -->
<nz-drawer
  [nzVisible]="outwardDrawerVisible"
  nzTitle="Outward Stock Details"
  (nzOnClose)="closeDrawer()"
  [nzWidth]="520"
>
  <ng-container *nzDrawerContent>
    <div class="drawer-content">
      <p>INward Stock List Details</p>
    </div>
  </ng-container>
</nz-drawer>
